/*
  Prepend an "Empty" entry to the specified array of options
*/
export default function prependEmptyOption(options: Array<object>) {
  return [{ id: -1, name: '(Empty)' }, ...options]
}
